<template>
	<div class="col-md-12 mx-auto">
		<div class="card mt-12">
			<div class="card-header bg-primary text-white">
				<page-title :title="($t(titleKey))"></page-title>
			</div>

			<div class="card-body">
				<div class="loader" v-if="loading"></div>
				<div v-else>
					<div class="btn-toolbar justify-content-between mt-3" role="toolbar">
						<div class="col-4">
							<button class="btn btn-primary" v-if="claims.organizationalModelsRegister.create" @click.stop="create">{{ $t('buttons.create.btnText')}}</button>
						</div>
						<div class="col-4 input-group col-sm-3" v-cloak>
							<div class="input-group-addon fa fa-search pt-3" style="display:table-cell"></div>
							<input class="form-control fa fa-search" name="query" v-model="searchQuery" />
						</div>
					</div>
					<custom-grid
						:data="source"
						:columns="gridColumns"
						:filter-key="searchQuery"
						:captions="gridCaptions"
						:gridName="'OrganizationalModels'"
						:btns="gridBtns"
						:readonly="true"
					></custom-grid>
				</div>
			</div>
		</div>
        <JsonFormatter
            v-model="dataReferences"
            :show.sync="showDataReferences"
            :titleKey="'buttons.links.tooltipText'"
            @onClose="onDataReferencesClose"
        >
        </JsonFormatter>
	</div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle';
import { Culture } from '@/models/enums';
import { OrganizationalModel } from '@/models/models';
import CustomGrid from '@/components/grid/CustomGrid';
import { mapGetters } from 'vuex';
import dataReferencesService from "@/services/dataReferences.service";
import JsonFormatter from "@/components/common/json.formatter.modal.vue";

export default {
	components: {
		PageTitle,
		CustomGrid,
        JsonFormatter
	},
	props: {
		showBtns: {
			default: true,
			type: Boolean
		}
	},
	data() {
		return {
			componentName: 'organizationalModelList',
			titleKey: 'organizationalModel.titles',
			loading: false,
			source: [],
			searchQuery: '',
			gridColumns: ['id', 'name', 'nameEn', 'description', 'eventForms', 'eventActivities', 'active'],
			gridCaptions: {
				id: 'organizationalModel.gridHeaders.id',
				name: 'organizationalModel.gridHeaders.name',
				nameEn: 'organizationalModel.gridHeaders.nameEn',
				description: 'organizationalModel.gridHeaders.description',
				eventForms: 'organizationalModel.gridHeaders.eventForms',
                eventActivities: 'organizationalModel.gridHeaders.eventActivities',
				deactivated: 'organizationalModel.gridHeaders.deactivated',
				active: 'organizationalModel.gridHeaders.active'
			},
            dataReferences: "",
            showDataReferences: false,
		};
	},
	methods: {
		loadOrganizationalModels() {
			this.loading = true;
			this.$http
				.get(`/api/organizationalModel/list`)
				.then(response => {
					if (response.data) {
						this.source = response.data;
					}

					this.loading = false;
				})
				.catch(error => {
					this.loading = false;

					this.$vs.notify({
						title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
						text: this.$helpers.errorText(error),
						color: 'danger',
						time: this.$store.getters.notificationDuration
					});
				});
		},
		create() {
			let that = this;
			kendo.prompt(this.$t('namePromptTitle')).then(
				data => {
					if (!data) {
						that.$vs.notify({
							title: `${that.$t('organizationalModel.title')} - ${that.$t('organizationalModel.gridHeaders.name')}`,
							text: that.$t('missingData'),
							color: 'warning',
							time: that.$store.getters.notificationDuration
						});

						return;
					}

					that.doCreate(data);
				},
				() => {}
			);
		},
		doCreate(name) {
			if (this.claims.organizationalModelsRegister.create) {
				let inputModel = new OrganizationalModel({ name: name });
				this.$http
					.post(`/api/organizationalModel/createModel`, inputModel)
					.then(response => {
						if (response.data.model) {
							this.$vs.notify({
								title: this.$t('buttons.create.action'),
								text: this.$helpers.responseMessage(response),
								color: 'success',
								time: this.$store.getters.notificationDuration
							});

							let model = new OrganizationalModel(response.data.model);
							if (model) {
								this.redirectForEdit(model);
							}
						} else {
							// Todo: notification
						}
					})
					.catch(error => {
						this.$vs.notify({
							title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
							text: this.$helpers.errorText(error),
							color: 'danger',
							time: this.$store.getters.notificationDuration
						});
					});
			}
		},
		redirectForEdit(model) {
			this.$router.push(`/organizationalModels/edit/${model.id}`);
		},
		modelEdit(args) {
			if (args.id) {
				this.$router.push(`/organizationalModels/edit/${args.id}`);
			}

			// Todo: notification
		},
		modelCopy(args) {
			if (args.id) {
				let that = this;
				kendo.prompt(this.$t('namePromptTitle')).then(
					data => {
						if (!data) {
							that.$vs.notify({
								title: `${that.$t('organizationalModel.title')} - ${that.$t('organizationalModel.gridHeaders.name')}`,
								text: that.$t('missingData'),
								color: 'warning',
								time: that.$store.getters.notificationDuration
							});

							return;
						}

						that.doCopy(args.id, data);
					},
					() => {}
				);
			}

			// Todo: notification
		},
		doCopy(id, name) {
			if (this.claims.organizationalModelsRegister.create) {
				let inputModel = new OrganizationalModel({ id: id, name: name });
				this.$http
					.post(`/api/organizationalModel/copyModel`, inputModel)
					.then(response => {
						if (response.data.model) {
							this.$vs.notify({
								title: this.$t('buttons.create.action'),
								text: this.$helpers.responseMessage(response),
								color: 'success',
								time: this.$store.getters.notificationDuration
							});

							let model = new OrganizationalModel(response.data.model);
							if (model) {
								this.redirectForEdit(model);
							}
						} else {
							// Todo: notification
						}
					})
					.catch(error => {
						this.$vs.notify({
							title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
							text: this.$helpers.errorText(error),
							color: 'danger',
							time: this.$store.getters.notificationDuration
						});
					});
			}
		},
        dataReferencesBtnClick(args) {
            if (!this.claims.dataReferences.read) {
                return this.$router.push(`/unauthorized`);
            }

            return this.getDataReferences(args.id);
        },
        getDataReferences(id) {
            dataReferencesService
                .checkReferences("O", "OrgModel", id, this.dataReferencesListCount, true)
                .then((response) => {
                    if (response.data) {
                        this.dataReferences = response.data;
                    }

                    this.showDataReferences = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onDataReferencesClose() {
            this.dataReferences = "";
            this.showDataReferences = false;
        },
	},
	mounted: function() {
		this.loadOrganizationalModels();
	},
	computed: {
        ...mapGetters(['claims', 'dataReferencesListCount']),
		token: function() {
			return this.$store.getters.authToken;
		},
		isEnVersion() {
			return this.$store.getters.currentCulture === Culture.EN;
		},
		gridBtns() {
			return [
				{
					name: 'edit',
					text: '',
					tooltip: this.$t('buttons.edit.btnText'),
					class: 'btn btn-success',
					icon: 'fas fa-edit',
					show: this.claims.organizationalModelsRegister.update,
					clickHandler: this.modelEdit
				},
				{
					name: 'copy',
					text: '',
					tooltip: this.$t('buttons.copy.btnText'),
					class: 'btn btn-info',
					icon: 'fas fa-copy',
					show: this.claims.organizationalModelsRegister.create,
					clickHandler: this.modelCopy
				},
                {
                    name: "checkLinks",
                    text: "",
                    tooltip: this.$t("buttons.links.btnText"),
                    class: "btn btn-info",
                    icon: "fa fa-link",
                    show: this.claims.dataReferences.read,
                    clickHandler: this.dataReferencesBtnClick,
                },
			];
		}
	}
};
</script>

<style scoped>
</style>
